import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork"; 
export const getBankList = createAsyncThunk(
  "/bankListSlice/get",
  async (_, { rejectWithValue }) => {
    try {
      // authToken eklenecek cookie,local vs biryerden okunup
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/virtualpos/firmvirtualpos");

      if (isSuccess ) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e) {
      return rejectWithValue(e.data.message);
    }
  }
);

export const bankListSlice = createSlice({
  name: "bankList",
  initialState: {
    bankList: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.bankList = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBankList.fulfilled, (state, { payload }) => {

      var vpTemp = [];
      payload?.map((vp) => {
        if (vp.status) {
          vpTemp.push({
            value: vp.vpid,
            label: vp.vpdisplayname,
          });
        }
      });

      state.bankList = vpTemp;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      return state;
    });

    builder.addCase(getBankList.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      // state.errorMessage = payload.message;
    });
    builder.addCase(getBankList.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState } = bankListSlice.actions;

export const bankListSelector = (state) => state.bankList;

export const bankListReducer = bankListSlice.reducer;
